import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  type?: 'primary' | 'danger';
  value?: string | number;
  max?: number;
  hidden?: boolean;
  isDot?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    type: { default: 'primary' },
    value: { default: '' },
    max: { default: 99 },
    hidden: { type: Boolean, default: false },
    isDot: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { type: 'primary' | 'danger', value: string | number, max: number, hidden: boolean, isDot: boolean };



const showBadge = computed(() => !props.hidden && (props.value || props.isDot));

const content = computed(() => {
  if (props.isDot) return '';
  if (typeof props.value === 'number' && typeof props.max === 'number') {
    return props.value > props.max ? `${props.max}+` : props.value;
  }
  return props.value;
});

const badgeClass = computed(() => [
  'tui-badge',
  `tui-badge-${props.type}`,
  props.isDot ? 'tui-badge-isDot' : '',
]);

return { __sfc: true,props, showBadge, content, badgeClass }
}

})